import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ecommerceBaseUrl } from "network";

export const colorSlice = createApi({
    reducerPath: "colorSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: ecommerceBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getColors: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/color?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addColors: builder.mutation({
            query: (body) => ({
                url: "/color",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateColors: builder.mutation({
            query: ({ id, body }) => ({
                url: `/color/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteColors: builder.mutation({
            query: (id) => ({
                url: `/color/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetColorsQuery,
    useAddColorsMutation,
    useUpdateColorsMutation,
    useDeleteColorsMutation
} = colorSlice;
